import SimplePage from "@/components/layout/SimplePage";
import RichHtml from "@/components/RichHtml";
import { useContent } from "@/hooks/useContent";

const FALLBACK = `
  <p class="font-display text-2xl" style="color: var(--blue-ink); line-height: 1.35;">Dear friends,</p>
  <p>On behalf of the entire Board of Trustees, I am delighted to welcome you to Temple Israel of Brevard.
     Whether you are a longtime member, a visiting snowbird, a newcomer to Brevard County, or simply curious
     about Reform Jewish life on the Space Coast &mdash; you are welcome here.</p>
  <p>TIOB has been a spiritual home for Brevard&rsquo;s Jewish community since 1965. Over six decades we have
     grown, moved, and evolved &mdash; but what has never changed is our commitment to inclusion, joyful worship,
     lifelong learning, and tikkun olam.</p>
  <p>If you have not yet visited, please come. Friday-night Shabbat services begin at 7:00 PM and visitors
     are always welcome. If you&rsquo;d like to chat about membership, programming, or how you might get involved,
     please reach out to the office.</p>
  <p class="font-display text-xl mt-8" style="color: var(--blue-ink);">With warm regards,<br />The President, TIOB Board of Trustees</p>
`;

export default function President() {
  const { body } = useContent("president.message", FALLBACK);
  return (
    <SimplePage
      title="Message from Our President"
      eyebrow="From the Bimah"
      subtitle="A welcome note from the President of the Temple Israel of Brevard Board of Trustees."
      path="/about/president"
      ctaLabel="Visit us for Shabbat"
      ctaTo="/worship/shabbat"
    >
      <RichHtml html={body} fallback={<div dangerouslySetInnerHTML={{ __html: FALLBACK }} />} />
    </SimplePage>
  );
}
